/**
 * Карточка события в kanban Interactions.
 * Дата: 17.07.2026
 */
import { format } from 'date-fns';
import { Badge } from '@/components/ui';
import { formatPhone } from '@/utils/formatters';
import { CHANNEL_ICONS, CHANNEL_LABELS, type InteractionEvent } from '@/types/interaction';
import {
  getInteractionAppointmentLabel,
  getInteractionFlowLabel,
  getInteractionPatientDisplayName,
  getInteractionStatusMeta,
  isOkdocShortlinkSource,
} from '@/features/interactions/utils/interactionDisplay';

export function InteractionEventCard({ event }: { event: InteractionEvent }) {
  const time = new Date(event.created_at);
  const appointmentLabel = getInteractionAppointmentLabel(event);
  const flowLabel = getInteractionFlowLabel(event);
  const patientLabel = getInteractionPatientDisplayName(event) || 'Пациент';
  const status = getInteractionStatusMeta(event.status);

  return (
    <div className="rounded-xl border border-shell-border bg-shell-surface px-3 py-2.5 transition hover:bg-shell-hover">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-shell-text">{patientLabel}</p>
          <p className="mt-0.5 text-xs text-shell-muted">{formatPhone(event.phone)}</p>
        </div>
        <span className="shrink-0 whitespace-nowrap text-xs text-shell-muted">
          {format(time, 'HH:mm')}
        </span>
      </div>

      <div className="mt-2 flex flex-wrap items-center gap-1.5 text-xs text-shell-muted">
        <span>
          {CHANNEL_ICONS[event.source_channel] || ''}{' '}
          {CHANNEL_LABELS[event.source_channel] || event.source_channel}
        </span>
        {isOkdocShortlinkSource(event.source_channel) ? (
          <span className="rounded-full border border-shell-primary/20 bg-shell-primary-soft px-2 py-0.5 text-[10px] font-semibold text-shell-primary">
            okdoc.su
          </span>
        ) : null}
        {flowLabel ? (
          <span className="rounded-full border border-shell-success/20 bg-shell-success-soft px-2 py-0.5 text-[10px] font-semibold text-shell-success">
            {flowLabel}
          </span>
        ) : null}
      </div>

      {appointmentLabel ? (
        <div className="mt-2 rounded-lg border border-shell-border-soft bg-shell-elevated/60 px-2.5 py-1.5 text-xs text-shell-muted">
          Запись: <span className="font-semibold text-shell-text">{appointmentLabel}</span>
        </div>
      ) : null}

      <div className="mt-2">
        <Badge className={`border text-[10px] ${status.className}`}>{status.label}</Badge>
      </div>
    </div>
  );
}
